import React, { useEffect, useState } from "react";
import Select, { components } from "react-select";
import plus from "../Assets/vehicle/plus.svg";
import search from "../Assets/rider/search.svg";
import { useNavigate } from "react-router-dom";
import "../Style/Component/Paymenttable.css";
import { useSelector } from "react-redux";
import {
  deleteWithTokenAPI,
  getWithTokenAPI,
  postWithTokenAPI,
  putWithTokenAPI,
} from "../Util/Api.js";
import { toast } from "react-toastify";
import GoogleMapModal from "./GoogleMapModal";
import Swal from "sweetalert2";
import {
  Pencil,
  Trash,
  Save,
  MapPin,
  ChevronsLeftRightEllipsisIcon,
} from "lucide-react";
import { TableSkeleton } from "./Skeleton.jsx";
const Paymenttable = ({ type }) => {
  const navigate = useNavigate();
  const auth = useSelector((state) => state.auth);
  const token = auth.token;
  const permission = auth.permission;
  const [tpage, setTpage] = useState(null);
  const [page, setPage] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [status, setStatus] = useState(" ");
  const [isedit, setIsEdit] = useState(null);
  const [editRowData, setEditRowData] = useState({});
  const [loading, setLoading] = useState(false);

  const toggleEdit = (id, row) => {
    if (isedit === id) {
      setIsEdit(null);
      setEditRowData({});
    } else {
      setIsEdit(id);
      setEditRowData({ ...row });
    }
  };

  const statusoptions = [
    { value: "", label: "All" },
    { value: "Active", label: "Active" },
    { value: "Inactive", label: "InActive" },
  ];
  const vehicleOptions = [
    { value: "Car", label: "Car" },
    { value: "Bike", label: "Bike" },
    { value: "Auto", label: "Auto" },
  ];

  const [showMap, setShowMap] = useState(false);
  const [editMapData, setEditMapData] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [initialDeposit, setInitialDeposit] = useState("");

  const formatINR = (amount) => {
    if (!amount || amount === 0) return "0";
    return `₹ ${amount.toLocaleString("en-IN")}`;
  };
  const SingleValueWithLabel = (label) => (props) => (
    <components.SingleValue {...props}>
      <span className="filter-prefix">{label} :</span>
      <span className="filter-value">{props.data.label}</span>
    </components.SingleValue>
  );

  const PlaceholderWithLabel = (label) => (props) => (
    <components.Placeholder {...props}>
      <span className="filter-prefix">{label} :</span>
      <span className="filter-placeholder">All</span>
    </components.Placeholder>
  );
  const customStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: "36px",
      height: "36px",
      minWidth: "150px",
      maxWidth: "80%",
      border: "none",
      boxShadow: state.isFocused ? "0 0 0 2px rgba(1,58,40,0.15)" : "none",
      backgroundColor: "white",
      paddingLeft: "30px",
      cursor: "pointer",
    }),

    valueContainer: (base) => ({
      ...base,
      padding: "0 8px",
      height: "36px",
      display: "flex",
      flexWrap: "nowrap", // ❌ prevent wrapping
      overflowX: "auto", // ✅ horizontal scroll
      overflowY: "hidden",
    }),

    singleValue: (base) => ({
      ...base,
      color: "#555",
      fontSize: "14px",
      fontWeight: "500",
      margin: 0,
      lineHeight: "36px",
      top: "0",
      transform: "none",
    }),

    multiValue: (base) => ({
      ...base,
      flexShrink: 0, // prevents items from shrinking
    }),

    placeholder: (base) => ({
      ...base,
      color: "#888",
      fontSize: "14px",
      fontWeight: "500",
    }),

    dropdownIndicator: (base) => ({
      ...base,
      color: "#666",
      padding: "0 10px",
      "&:hover": {
        color: "#333",
      },
    }),

    indicatorSeparator: () => ({
      display: "none",
    }),

    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? "#013A28"
        : state.isFocused
          ? "#02543a53"
          : "white",
      color: state.isSelected ? "white" : "#333",
      cursor: "pointer",
      ":hover": {
        backgroundColor: state.isSelected ? "#013A28" : "#02543a53",
      },
    }),

    menu: (base) => ({
      ...base,
      borderRadius: "8px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
      zIndex: "99",
    }),

    menuList: (base) => ({
      ...base,
      padding: 0,
      maxHeight: "180px",
      overflowY: "auto",
      zIndex: "99",

      "&::-webkit-scrollbar": {
        width: "6px",
      },
      "&::-webkit-scrollbar-track": {
        background: "#013a2826",
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#013a2855",
        borderRadius: "3px",
      },
    }),
  };
  const [tableData, setTableData] = useState([]);
  console.log(tableData, "tableDatatableDatatableData");
  const fetchtablevalues = async () => {
    try {
      setLoading(true);
      const res = await getWithTokenAPI(
        token,
        `/admin/city/list-all?page=${page}&limit=10&search=${searchText}&status=${status}`,
      );

      setTableData(res?.data?.data);
      setTpage(res?.data?.totalPages);
    } catch (err) {
      console.log("Error fetching list", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (type !== "driver") {
      fetchtablevalues();
    }
  }, [token, page, status, searchText]);

  const fetchtPayments = async () => {
    try {
      setLoading(true);
      const res = await getWithTokenAPI(
        token,
        `/user/getall?limit=10&page=${page}&roletype=driver&search=${searchText}`,
      );

      setTableData(res?.data?.data);
      setTpage(res?.data?.totalpage);
    } catch (err) {
      console.log("Error fetching list", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (type === "driver") {
      fetchtPayments();
    }
  }, [token, page, status, searchText]);

  const handleDepositChange = (e) => {
    const value = e.target.value.replace(/,/g, ""); // remove commas
    if (!isNaN(value)) {
      setInitialDeposit(value);
    }
  };

  const fetchDriverRadius = async () => {
    try {
      const res = await getWithTokenAPI(token, "/admin/driver-radius");

      if (res) {
        setInitialDeposit(res?.driverRadiusKm?.drivercommission);
      }
    } catch (error) {
      console.log("Error fetching driver Commission", error);
    }
  };
  useEffect(() => {
    fetchDriverRadius();
  }, [token]);
  const handleUpdateDeposit = async () => {
    try {
      const payload = {
        drivercommission: Number(initialDeposit),
      };

      const res = await putWithTokenAPI(token, "/admin/driver-radius", payload);

      if (res) {
        toast.success("Driver Rent Updated Successfully");
        fetchDriverRadius();
      }
    } catch (error) {
      toast.error("Failed to update driver Rent");
      console.log("Error updating driver Rent", error);
    }
  };
  const handleCreateCity = async (payload) => {
    try {
      console.log("Creating city with payload:", payload);

      await postWithTokenAPI(token, "/admin/city/create", payload);

      toast.success("City Created Successfully");
      setPage(1);
      setShowMap(false);
      await fetchtablevalues();
    } catch (err) {
      console.log(err);
      toast.error("City Creation Failed");
    }
  };

  const handleUpdateCity = async (id, updatedData) => {
    try {
      await putWithTokenAPI(token, `/admin/city/update/${id}`, updatedData);

      toast.success("City Updated Successfully");
      await fetchtablevalues();
      setIsEdit(null);
    } catch (err) {
      console.log(err);
      toast.error("City Updation Failed");
    }
  };

  const confirmDelete = (id) => {
    Swal.fire({
      title: "Delete City?",
      text: "Are you sure you want to delete the City?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#ba1b1b",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, Delete",
    }).then((result) => {
      if (result.isConfirmed) {
        handledeletecity(id);
      }
    });
  };

  const handledeletecity = async (id) => {
    try {
      const response = await deleteWithTokenAPI(
        token,
        `/admin/city/delete/${id}`,
      );
      if (response?.data) {
        toast.success("City Deleted Successfully");
        fetchtablevalues();
      } else {
        toast.error("City Deletion Unsuccessful");
      }
    } catch (err) {
      toast.error(err);
    }
  };
  const columns =
    type === "driver"
      ? [
        "ID",
        "Driver",
        "Phone",
        "Vehicle",
        "Rides",
        "Ride Amount",
        "Monthly Rent",
        "Actions",
      ]
      : [
        "ID",
        "City",
        "District",
        "Vehicle",
        "Rides",
        "Riders",
        "Customers",
        "Actions",
      ];

  return (
    <div className="paymenttable">
      <div className={type === "driver" ? "pt" : "approvalpagehead"}>
        <span className="head">{type === "driver" ? "Payment" : "Cities"}</span>
        {type === "driver" && (
          <div className="deposit-wrapper">
            <label className="deposit-label">Monthly Rent</label>
            <div className="deposit-input-group">
              <input
                type="text"
                // placeholder="Driver Rent"
                value={initialDeposit}
                onChange={handleDepositChange}
                className="deposit-input-modern"
              />
              <span className="deposit-prefix">%</span>
              <button
                className="deposit-update-btn"
                onClick={handleUpdateDeposit}
              >
                Update
              </button>
            </div>
          </div>
        )}
        <div className="approvaltopfilter">
          <div className="searchbar">
            <img src={search} alt="search" />
            <input
              className="searchinput"
              type="text"
              placeholder="Search"
              value={searchText}
              onChange={(e) => {
                setSearchText(e.target.value);
                setPage(1);
              }}
            />
          </div>
          {type !== "driver" && (
            <div className="filter-select">
              <Select
                value={status.value}
                options={statusoptions}
                styles={customStyles}
                onChange={(selected) => {
                  setStatus(selected.value);
                  setPage(1);
                }}
                isSearchable={false}
                menuPlacement="bottom"
                // menuPortalTarget={document.body}
                menuPosition="fixed"
                components={{
                  SingleValue: SingleValueWithLabel("Status"),
                  Placeholder: PlaceholderWithLabel("Status"),
                  IndicatorSeparator: null,
                }}
                classNamePrefix="react-select"
              />
              {permission?.location?.create && (
                <div
                  className="addnewcard"
                  style={{
                    width: "130px",
                    backgroundColor: "black",
                    color: "white",
                  }}
                  onClick={() => setShowMap(true)}
                >
                  <img src={plus} />
                  Add new City
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      {loading ? (
        <TableSkeleton columns={columns} />
      ) : (
        <div className="paymenttablebody">
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>{type === "driver" ? "Driver" : "City"}</th>
                <th>{type === "driver" ? "Phone" : "District"}</th>
                <th>Vehicle</th>
                <th>Rides</th>
                <th>{type === "driver" ? "Ride Amount" : "Riders"}</th>
                <th>{type === "driver" ? "Monthly Rent" : "Customers"}</th>
                <th style={{ paddingLeft: "2vw" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {tableData?.map((row, index) => (
                <tr key={row?._id}>
                  <td>{(page - 1) * 10 + (index + 1)}</td>

                  <td
                    onClick={
                      type === "driver"
                        ? () =>
                          navigate(`/admin/drivervehicledetails/prices/${row?._id}`)
                        : undefined
                    }
                    style={{
                      cursor: type === "driver" ? "pointer" : "default",
                      fontWeight: "500",
                    }}
                  >
                    {type === "driver" ? row?.name : (Array.isArray(row?.city) ? row?.city.join(", ") : row?.city) || "-"}
                  </td>

                  <td>
                    {type === "driver" ? row?.phoneNumber : row?.district}
                  </td>

                  <td style={{ minWidth: "200px" }}>
                    {type === "driver" ? (
                      row.driverDetails?.vehicle?.vehicleModel || "-"
                    ) : isedit === row._id ? (
                      <Select
                        isMulti
                        options={vehicleOptions}
                        value={vehicleOptions.filter((opt) =>
                          editRowData?.vehicle?.includes(opt.value),
                        )}
                        onChange={(selected) => {
                          const updatedVehicles = selected.map((s) => s.value);

                          setEditRowData((prev) => ({
                            ...prev,
                            vehicle: updatedVehicles,
                          }));
                        }}
                        styles={customStyles}
                        // menuPortalTarget={document.body}
                        menuPosition="fixed"
                      />
                    ) : (
                      <span>
                        {row?.vehicle
                          ?.map(
                            (val) =>
                              vehicleOptions.find((opt) => opt.value === val)
                                ?.label,
                          )
                          .filter(Boolean)
                          .join(", ")}
                      </span>
                    )}
                  </td>

                  <td>{row?.driverRideCount}</td>

                  <td>
                    {type === "driver"
                      ? formatINR(row?.totalEarning)
                      : row?.riders}
                  </td>

                  <td>
                    {type === "driver"
                      ? row?.monthlyRent === ""
                        ? "-"
                        : row?.monthlyRent
                      : row?.customers || "-"}
                  </td>

                  {type === "driver" && (
                    <td>
                      <span
                        className={`paymenttablestatus ${row?.Status !== "paid" ? "status-red" : ""
                          }`}
                      >
                        <span className="dot"></span>
                        <span className="value">Un Paid</span>
                      </span>
                    </td>
                  )}
                  {type !== "driver" && (
                    <td
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <span
                        className={`paymenttablestatus ${row?.status !== "Active" ? "status-red" : ""
                          }`}
                        style={{
                          cursor: "pointer",
                        }}
                        onClick={
                          permission?.location?.update
                            ? () => {
                              const updatedStatus =
                                row.status === "Active"
                                  ? "Inactive"
                                  : "Active";

                              handleUpdateCity(row._id, {
                                ...row,
                                status: updatedStatus,
                              });
                            }
                            : undefined
                        }
                      >
                        <span className="dot"></span>
                        <span className="value">{row?.status}</span>
                      </span>

                      {isedit === row._id ? (
                        <>
                          <Save
                            size={18}
                            color="var(--primary)"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              handleUpdateCity(row._id, editRowData);
                              setIsEdit(null);
                              setEditRowData({});
                            }}
                          />

                          <Trash
                            size={18}
                            color="#960f0f"
                            style={{ cursor: "pointer" }}
                            onClick={() => confirmDelete(row._id)}
                          />
                        </>
                      ) : (
                        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                          {permission?.location?.update && (
                            <Pencil
                              size={18}
                              color="black"
                              style={{ cursor: "pointer" }}
                              onClick={() => toggleEdit(row._id, row)}
                            />
                          )}
                          {permission?.location?.update && (
                            <MapPin
                              size={18}
                              color="var(--primary)"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                setEditMapData(row);
                                setShowMap(true);
                              }}
                            />
                          )}
                        </div>
                      )}
                    </td>
                  )}
                </tr>
              ))}
            </tbody>

            <tfoot>
              <tr>
                <td colSpan="9">
                  {tpage > 1 && (
                    <div className="pagination">
                      {page > 1 && (
                        <button
                          className="page-btn"
                          onClick={() => setPage((page) => page - 1)}
                        >
                          ‹
                        </button>
                      )}
                      {page > 1 && (
                        <button className="page-btn" onClick={() => setPage(1)}>
                          1
                        </button>
                      )}
                      {page === tpage && <span className="page-dots">…</span>}
                      <button className="page-btn pgnoactive">{page}</button>

                      {page !== tpage && <span className="page-dots">…</span>}


                      {page !== tpage && (
                        <button
                          className="page-btn"
                          onClick={() => setPage(tpage)}
                        >
                          {tpage}
                        </button>
                      )}

                      {page < tpage && (
                        <button
                          className="page-btn"
                          onClick={() => setPage((page) => page + 1)}
                        >
                          ›
                        </button>
                      )}
                    </div>
                  )}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      )}
      {showMap && (
        <GoogleMapModal
          onClose={() => {
            setShowMap(false);
            setEditMapData(null);
          }}
          initialData={editMapData}
          onSelect={(payload) => {
            if (editMapData) {
              handleUpdateCity(editMapData._id, payload);
            } else {
              setSelectedLocation(payload);
              handleCreateCity(payload);
            }
            setEditMapData(null);
          }}
        />
      )}
    </div>
  );
};

export default Paymenttable;
